import classNames from 'classnames';
import { LinkFactoryReactRouter } from 'common/link/link-react-router.js';

import { IMenuItem } from 'types/menu.js';

interface IProps {
  item: IMenuItem;
  active?: boolean;
  className?: string;
  onClick?: () => void;
}

export const NavMenuItem = ({ item, active, className, onClick }: IProps) => {
  const { name, link, target } = item;
  const classes = classNames(className, { 'is-active': active });

  return (
    <li className={classes}>
      <LinkFactoryReactRouter href={link} target={target} onClick={onClick}>
        {name}
      </LinkFactoryReactRouter>
    </li>
  );
};
